import { render } from "./vadvertisersspread.vue?vue&type=template&id=10c77b3a&scoped=true"
import script from "./vadvertisersspread.vue?vue&type=script&lang=js"
export * from "./vadvertisersspread.vue?vue&type=script&lang=js"

import "./vadvertisersspread.vue?vue&type=style&index=0&id=10c77b3a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c77b3a"]])

export default __exports__